// src/utils/formulas.js

// VALORES DE REFERENCIA ISO 7243:2017
// Límites de exposición para personas aclimatadas y no aclimatadas (en °C)
export const ISO_LIMITS = {
  acclimatized: { 
    class0: 33, // Reposo
    class1: 30, // Ligera
    class2: 28, // Moderada
    class3: 25, // Pesada
    class4: 23  // Muy pesada
  },
  not_acclimatized: { 
    class0: 32, 
    class1: 29, 
    class2: 26, 
    class3: 22, 
    class4: 20 
  }
};

// VALORES DE AJUSTE POR ROPA (CAV - Clothing Adjustment Value)
export const CLOTHING_ADJUSTMENT = {
  conventional: 0,    // Ropa de trabajo normal
  coverall: 0.5,      // Overol de tela
  double_layer: 3,    // Doble capa (ej. overol sobre ropa)
  protective: 10      // Ropa de protección especial (aviso de riesgo)
};

/**
 * Determina el régimen de trabajo/descanso sugerido
 * @param {number} effective - WBGT calculado con ropa
 * @param {number} limit - Límite ISO según metabolismo
 */
export const getWorkRestCycle = (effective, limit) => {
  const diff = effective - limit;

  if (diff <= 0) return { work: "100%", rest: "0%", note: "Continuo", color: "text-green-600" };
  if (diff <= 1.5) return { work: "75%", rest: "25%", note: "45 min / 15 min", color: "text-yellow-600" };
  if (diff <= 3) return { work: "50%", rest: "50%", note: "30 min / 30 min", color: "text-orange-600" };
  if (diff <= 4.5) return { work: "25%", rest: "75%", note: "15 min / 45 min", color: "text-red-600" };
  return { work: "0%", rest: "100%", note: "ALTO TOTAL / HIDRATACIÓN URGENTE", color: "text-red-800" };
};

/**
 * Calcula el índice WBGT base
 */
export const calculateWBGT = (tgb, tg, ta = 0, withSolarLoad = false) => {
  const Tgb = parseFloat(tgb);
  const Tg = parseFloat(tg);
  const Ta = parseFloat(ta);

  if (withSolarLoad) {
    return (0.7 * Tgb + 0.2 * Tg + 0.1 * Ta);
  }
  return (0.7 * Tgb + 0.3 * Tg);
};

/**
 * Determina el estado del riesgo comparando el efectivo contra el límite ISO
 */
export const getHeatRiskStatus = (effectiveWBGT, limit, riskLabels = null) => {
  const diff = limit - effectiveWBGT;
  const labels = riskLabels || {};
  if (diff > 1) {
    return {
      label: labels.seguro || "Seguro",
      color: "text-green-600",
      bg: "bg-green-100",
      icon: "check",
    };
  }
  if (diff <= 1 && diff >= 0) {
    return {
      label: labels.precaucion || "Precaución",
      color: "text-yellow-600",
      bg: "bg-yellow-100",
      icon: "alert",
    };
  }
  return {
    label: labels.peligro || "Peligro: Exceso de Límite",
    color: "text-red-600",
    bg: "bg-red-100",
    icon: "hazard",
  };
};
/*<!--© 2026 Todos los derechos reservados Desarrollado por JEMAprod-Tecnologia-->*/